module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 457
// module chunks = 61